export default __webpack_public_path__ + "static/media/mutasi1.d5b6f72f.png";